export const produtos = {
    SUBITEMSELECIONADO: 'SUBITEMSELECIONADO',
    CODIGOPROMOSELECIONADO: 'CODIGOPROMOSELECIONADO',    
    PRODNOVOATUALIZA: 'PRODNOVOATUALIZA',
    PRODPRECOSPESQUISA: 'PRODPRECOSPESQUISA',
    SUBITEMPRECOSELECIONADO: 'SUBITEMPRECOSELECIONADO',
    PESQUISA_ITEM: 'PESQUISA_ITEM',
    PESQUISA_SUBITEM: 'PESQUISA_SUBITEM',
    PESQUISA_CODIGOPROMOCIONAL: 'PESQUISA_CODIGOPROMOCIONAL',
    PESQUISA_PEDIDOSITENS: 'PESQUISA_PEDIDOSITENS',
    FORMA_PAGAMENTO: 'FORMA_PAGAMENTO',
}